import { Select } from 'antd'
import { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../../../components/custom_components/BackgroundBox'
import PerButton from '../../../../components/custom_components/Button'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import { useSelectableNationalContractReferences } from '../../../../graphql/nationalContractReference/hooks/useSelectableNationalContractReferences'
import { NationalContractType } from '../../../../types'
import { HrSupportNationalContractReferenceCard } from './HrSupportNationalContractReferenceCard'
import { HrSupportNationalContractReferenceImportModal } from './HrSupportNationalContractReferenceImportModal'
import './index.less'
import { NewLoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'

const { Option } = Select

export const HrSupportNationalContractReferenceTab: FC = () => {
  const { t } = useTranslation()

  const [selectedType, setSelectedType] = useState<NationalContractType | undefined>(undefined)
  const [isImportModalVisible, setIsImportModalVisible] = useState(false)
  const { data, loading, error } = useSelectableNationalContractReferences()

  const references = useMemo(
    () => (data?.getSelectableNationalContractReferences ?? []).filter((reference) => reference.levels.length > 0),
    [data],
  )

  const filteredReferences = useMemo(() => {
    if (!selectedType) {
      return references
    }
    return references.filter((reference) => reference.type === selectedType)
  }, [references, selectedType])

  if (loading || error || !data) {
    return (
      <BackgroundBox r height="withTabs">
        <NewLoadingAndErrors isLoading={loading} hasNoData={!data || references.length === 0} error={error} showSpinner={loading} t={t} />
      </BackgroundBox>
    )
  }

  return (
    <div className="per-hr-support-national-contract-reference">
      <BackgroundBox r height="editImportExport" noPadding>
        <PerFlexRow align="middle" justify="space-between" noWrap className="fullHeight" mr="s" ml="s">
          <div className="per-hr-support-national-contract-reference__filter">
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder={t('companySettingsView.nationalContractReferenceTab.filterByType')}
              value={selectedType}
              onChange={(value) => setSelectedType(value)}
            >
              {references.map((reference) => (
                <Option key={reference.type} value={reference.type}>
                  {t(`employee.nationalContract.type.${reference.type}`)}
                </Option>
              ))}
            </Select>
          </div>
          <PerButton text={t('global.button.import')} color="success" before="import_fill" onClick={() => setIsImportModalVisible(true)} />
        </PerFlexRow>
      </BackgroundBox>

      <HrSupportNationalContractReferenceImportModal
        visible={isImportModalVisible}
        references={references}
        onClose={() => setIsImportModalVisible(false)}
      />

      <div
        className={`per-hr-support-national-contract-reference__cards${
          selectedType ? ' per-hr-support-national-contract-reference__cards--filtered' : ''
        }`}
      >
        {filteredReferences.map((reference) => (
          <div key={reference.type} className="per-hr-support-national-contract-reference__card-cell">
            <HrSupportNationalContractReferenceCard reference={reference} />
          </div>
        ))}
      </div>
    </div>
  )
}
